import { render } from "./clients.vue?vue&type=template&id=1ba97e3d&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"

import "./clients.vue?vue&type=style&index=0&id=1ba97e3d&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba97e3d"]])

export default __exports__